import { forceArray } from 'navigation/component/Component';
import Form from 'components/form/Form';
import AddToWishlist from 'components/add-to-wishlist/AddToWishlist';
import { getRoot } from 'core/router';
import tag from 'core/tag';
import { bindEmitterMethod, bindMethod } from 'helpers/bind';
import { completeAddToCart, sendProductForm, startAddToCartLoading } from 'helpers/addToCartButton';
import store from 'store';
import Product from './Product';
import BundleProductRow from './partials/BundleProductRow';
import ProductInfos from './partials/ProductInfos';
class BundleProduct extends Product {
    static pageName = 'BundleProduct';
    getModulesMap() {
        return {
            ...super.getModulesMap(),
            bundleProductRow: ['.bundle-product-row', BundleProductRow],
            forms: ['.bundle-product-details__group.form', Form],
            infos: ['.product-infos', ProductInfos],
            addToWishlist: ['.bundle-product-details__group .add-to-wishlist', AddToWishlist]
        };
    }
    pageName() {
        return 'BundleProduct';
    }
    bindEvents(add) {
        super.bindEvents(add);
        const method = bindMethod(add);
        const emitterMethod = bindEmitterMethod(add);
        this.rows.forEach((row) => row[emitterMethod]('size:open', this.openSizePanel));
        if (this.modules.addToWishlist)
            this.modules.addToWishlist[emitterMethod]('toggle', this.onWishlistToggle);
        if (this.modules.addToWishlistLarge)
            this.modules.addToWishlistLarge[emitterMethod]('toggle', this.onWishlistToggle);
        this.addToCartButtons.forEach((btn) => btn[method]('click', this.onAddToCart));
        if (this.barAddToCart)
            this.barAddToCart[method]('click', this.onAddToCart);
        window[method]('bundle:update-size', this.onSizePanelChange);
        window[method]('bundle:update-color', this.onColorPanelChange);
    }
    // sorted by item index: a row re-created after a color change is appended at the end of the modules array
    get rows() {
        return forceArray(this.modules.bundleProductRow)
            .filter(Boolean)
            .sort((a, b) => Number(a.el.dataset.index) - Number(b.el.dataset.index));
    }
    get addToCartButtons() {
        if (!this.modules.forms)
            return [];
        return forceArray(this.modules.forms)
            .map((form) => form.el.querySelector('[data-refs="addToCart"]'))
            .filter(Boolean);
    }
    get barAddToCart() {
        return this.modules.bar?.el.querySelector('[data-refs="addToCart"]') ?? null;
    }
    openSizePanel = (index) => {
        const { article, article_2: article2 } = forceArray(this.modules.forms)[0].getFormValues();
        const params = new URLSearchParams({ items: this.rows.map((row) => row.el.dataset.productId).join('-') });
        if (index !== undefined)
            params.set('index', index.toString());
        const current = [article, article2].filter(Boolean).join(',');
        if (current)
            params.set('current', current);
        tag.openPopin('panel', 'panel');
        store.panel.set(`${this.refs.productDetailsInner.dataset.sizePanel}?${params}`.replace(getRoot(), ''));
    };
    onWishlistToggle = ({ active }) => {
        this.modules.addToWishlist?.setState(active);
        this.modules.addToWishlistLarge?.setState(active);
        forceArray(this.modules.bundleProductRow).forEach((row) => row.modules.addToWishlist?.setState(active));
    };
    onSizePanelChange = (e) => {
        this.onSizeChange(e.detail);
    };
    onSizeChange = (e) => {
        this.rows.forEach((row) => row.syncSize(e));
        forceArray(this.modules.forms).forEach((form) => {
            forceArray(form?.refs.sizeInput).forEach((input) => {
                if (!input || e[input.name] === undefined)
                    return;
                input.value = e[input.name];
                input.dispatchEvent(new Event('change'));
            });
        });
    };
    onColorPanelChange = async (e) => {
        const { index, productId } = e.detail;
        const row = this.rows.find((r) => Number(r.el.dataset.index) === index);
        if (!row)
            return;
        const params = new URLSearchParams({ product: productId, index: index.toString() });
        const response = await fetch(`${this.refs.productDetailsInner.dataset.rowUrl}?${params}`);
        if (!response.ok)
            return;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const newRow = html.querySelector('.bundle-product-row');
        if (!newRow || !row.el.isConnected)
            return;
        // the selected size belongs to the previous product: clear it everywhere
        this.onSizeChange({ [index > 0 ? 'article_2' : 'article']: '', label: '' });
        row.el.replaceWith(newRow);
        // flushes the detached row module, instantiates the new one and re-binds page events on it
        this.refresh();
    };
    onAddToCart = async (e) => {
        const btn = e.currentTarget;
        const form = forceArray(this.modules.forms).find((f) => f.el === btn.closest('form')) || forceArray(this.modules.forms)[0];
        if (!form)
            return;
        form.setSubmitted(false);
        if (!(await form.quickValid())) {
            this.openSizePanel();
            return;
        }
        const btns = btn === this.barAddToCart ? [btn, ...this.addToCartButtons] : [btn];
        await startAddToCartLoading(btns);
        sendProductForm({
            form,
            submitter: btn,
            callback: ({ data }) => completeAddToCart(btns, data.error !== null)
        });
    };
}
export default BundleProduct;
